export default {
  label: "訂閱 API DEMO",
  index: {
    items: [
      {
        module: '法規',
        value: 'act',
      }
    ],
    headers: [
      {
        text: "模組",
        value: "module",
        width: undefined,
      },
      {
        fixed: true,
        sortable: false,
        text: "",
        value: "actions",
        width: "80.1px",
      }
    ],
    fields: {
      module: {
        type: 'text',
        label: '模組',
      },
    },
  },
  read: {
    breadcrumbsItems: [
      {
        text: "訂閱 API DEMO",
        to: "/subscription_api_demo",
        disabled: false,
      },
    ],
    headers: [
      {
        text: "法規名稱",
        value: "name",
        width: undefined,
      },
    ],
    fields: {
      name: {
        type: "text",
        label: "法規名稱",
      },
    },
    displayFields: {
      all: {
        type: "text",
        label: "法規",
      },
    }
  },
}